<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {on} from 'element-ui/lib/utils/dom'
export default {
  name: 'App',
  mounted () {
    /* 监听相关标签 */
    on(document.body, 'click', event => {
      let target = event.target || event.srcElement
      while (target && target.nodeName !== 'HTML') {
        if (target.nodeName === 'A') {
          let href = target.getAttribute('href')
          if (href && href.startsWith('/')) {
            event.preventDefault()
            this.$store.dispatch('globalActionParams', href).then(params => {
              let query = []
              if (params) {
                Object.entries(params).forEach(([key, val]) => {
                  if (Array.isArray(val)) {
                    val.forEach(v => {
                      query.push(`${key}=${v}`)
                    })
                  } else {
                    query.push(`${key}=${val}`)
                  }
                })
              }
              let openUrl
              if (query.length) {
                if (href.includes('?')) {
                  openUrl = href + '&' + query.join('&')
                } else {
                  openUrl = href + '?' + query.join('&')
                }
              } else {
                openUrl = href
              }
              let to = target.getAttribute('target') || '_self'
              window.open(openUrl, to)
            }).catch(err => {
              this.$message({
                message: err.message,
                type: 'warning',
                center: true
              })
            })
          }
          break
        }
        target = target.parentNode
      }
    })
  }
}
</script>

<style lang="scss">
  @use "styles/index" as *;
  @import "assets/iconfont/iconfont.css";
  #app {
    height: 100%;
  }
</style>
